import ComponentModule from "@eisinc/Overrides/Components/LocationSearchForm";

export * from "@eisinc/Overrides/Components/LocationSearchForm";

export default ComponentModule;
